<template>
  <v-row
    class="d-flex"
    no-gutters
  >
    <v-col class="flex-shrink-1 flex-grow-0">
      <sn-search
        v-if="!hideSearch"
        hide-default-margin
        :placeholder="searchPlaceholder"
        :value="searchText"
        @input="$emit('search:input', $event)"
        v-on="$listeners"
      />
    </v-col>
    <v-col>
      <filter-chip
        v-for="header in filteredHeaders"
        :key="header.value"
        :header="header"
        v-on="$listeners"
      />
    </v-col>
    <v-col class="d-flex flex-row-reverse flex-shrink-1 flex-grow-0">
      <table-actions
        :actions="actions"
        v-on="$listeners"
      />
    </v-col>
  </v-row>
</template>

<script>
import SnSearch from '~/components/snui/v2/snSearch/snSearch'
import FilterChip from './sortAndFilter/filterChip'
import TableActions from './tableActions'

export default {
  name: 'DefaultTopSlot',
  components: {
    SnSearch,
    FilterChip,
    TableActions
  },
  props: {
    hideSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: null
    },
    searchText: {
      type: String,
      required: false,
      default: null
    },
    filteredHeaders: {
      type: Array,
      required: false,
      default: () => []
    },
    actions: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
